import { useEffect, useRef, useState } from "react";
import Block from "../../components/Base/Block";
import View from "../../components/Base/View";
import CommonList from "../../components/CommonList";
import EmptyTip from "../../components/EmptyTip";
import Loading from "../../components/Loading";
import cartMaganer from "../../manager/cart";
import './myFav.scss'

const MyFav = () => {

    const [products, setProducts] = useState<any[]>([]);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [noMore, setNoMore] = useState<boolean>(false);
    const [loadFailed, setLoadFail] = useState<boolean>(false);
    const pageNum = useRef<number>(0);

    const loadList = (isRefresh: boolean) => {
        if (!isRefresh && (isLoading || noMore)) {
            return
        }
        if (isRefresh) {
            pageNum.current = 0
            setNoMore(false)
            setLoadFail(false)
        }
        setLoading(true)
        cartMaganer.getFav(
            pageNum.current,
            function (success: boolean, data: any, tips: string) {
                if (success) {
                    setProducts(isRefresh
                        ? data.data.Content
                        : products.concat(data.data.Content))
                    if (data.data.Content.length > 0) {
                        pageNum.current = pageNum.current + 1
                    } else {
                        setNoMore(true)
                    }
                } else {
                    setLoadFail(true)
                }
                setLoading(false)
            }
        )
    }
    useEffect(()=>{
        document.title = "我的收藏";
        loadList(true);
    }, [])

    return <View
        className="page-root fav-list-page"
    >
        <CommonList sources={products}></CommonList>
        {isLoading ? (
            <Loading
                style={{
                    width: 25,
                    height: 25,
                    marginTop: 25,
                    marginBottom: 25,
                    opacity: 0.5
                }}

            ></Loading>
        ) : (
            ((noMore && products?.length > 0) || loadFailed) && (
                <Block>
                    <View
                        className="loading-tip"
                        // onClick={loadFailed ? 'retryLoadMore' : ''}
                    >
                        {noMore ? '没有更多了' : '加载失败，点我重试'}
                    </View>
                </Block>
            )
        )}
        {/*  <view class="empty-tip" wx:if="{{!isLoading[0] && !loadFailed[0] && products.length===0 }}">没有收藏</view>  */}
        {!isLoading && !loadFailed && products?.length === 0 && (
            <EmptyTip
                data={{
                    icon: require('../../images/empty-fav.png'),
                    tip: '暂无收藏',
                    // btn: '',
                }}
            // emptyBtnClick={this.emptyBtnClick}
            ></EmptyTip>
        )}
    </View>
}

export default MyFav;